import { apiService } from './apiService';

export function getItemVariationService(data) {
    return apiService({
        method: 'POST',
        url: '/item-variation/data',
        data,
        onSuccess: (dispatch, res) => {},
        onFailure: () => {},
    });
}

export function getByIdItemVariationService(id) {
    return apiService({
        method: 'GET',
        url: '/item-variation/' + id,
        onSuccess: (dispatch, res) => {},
        onFailure: () => {},
    });
}

export function addItemVariationService(data) {
    return apiService({
        method: 'POST',
        url: '/item-variation',
        data,
        onSuccess: (dispatch, res) => {},
        onFailure: () => {},
    });
}

export function updateItemVariationService(id, data) {
    return apiService({
        method: 'PUT',
        url: '/item-variation/' + id,
        data,
        onSuccess: (dispatch, res) => {},
        onFailure: () => {},
    });
}

export function deleteItemVariationService(id) {
    return apiService({
        method: 'DELETE',
        url: '/item-variation/' + id,
        onSuccess: (dispatch, res) => {},
        onFailure: () => {},
    });
}
